import { useEffect, useRef, useState } from "react";

const useInboundSocket = (extensionsIn = []) => {
  const socketRef = useRef(null);
  const [statuses, setStatuses] = useState({});

  useEffect(() => {
    if (!extensionsIn.length) return;
const userInfo = JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_INFO) ||  localStorage.getItem(process.env.REACT_APP_USER_INFO_HOROSCOPE));
    const accountId = userInfo.account_id;
    const socket = new WebSocket("wss://app.gocc.pro/as_manager_light");
    socketRef.current = socket;

    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          type: "connect",
          data: {
            account_id: accountId,
            extensions: extensionsIn,
          },
        })
      );

      socket.send(
        JSON.stringify({ type: "getExtensionInboundStatus" })
      );
    };

    socket.onmessage = (event) => {
      const resp = JSON.parse(event.data);

      if (resp.type === "syncDataExtInStatus") {
        const map = {};
        resp.data.forEach((item) => {
          map[item.extension] = item;
        });
        setStatuses((prev) => ({ ...prev, ...map }));
      } 
       if (resp.type === "statusInExtension") {
          const map = {};
        resp.data.forEach((item) => {
          map[item.extension] = item;
        });
        setStatuses((prev) => ({ ...prev, ...map }));
       }
    };

    socket.onerror = (e) => console.error("Socket error", e);
    socket.onclose = () => console.log("Socket closed");

    return () => socket.close();
  }, [JSON.stringify(extensionsIn)]);

  return statuses;
};

export default useInboundSocket;
